<template>
  <div class="container">
    <div class="row">
      <div class="col-lg-2"></div>
      <div class="col-lg-4 col-xs-12 p-2 pt-4">
        <a href="https://jovool.com">
          <img src="/images/Jovool_logo.png" />
        </a>
      </div>
      <div style="text-align: right" class="pt-4 col-lg-4 col-xs-12">
        <h1 class="color-primary">FEDDBACK</h1>
      </div>
      <div class="col-lg-2"></div>
    </div>
    <div class="row">
      <div class="col-lg-2 col-xs-12"></div>
      <div class="col-lg-8 col-xs-12">
        <div class="card card-body p-5">
          <video
            class="full"
            controls
            controlslist="nodownload"
            v-if="feedback.use_video"
          >
            <source :src="item.video" />
          </video>
          <div class="mt-3" v-html="feedback.additional_text"></div>
        </div>
      </div>
      <div class="col-lg-2 col-xs-12"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["feedback", "item"],
};
</script>

<style>
</style>